import { HGIntersectionType } from "@/common/types";
import {
  Dot,
  ArrowLeft,
  ArrowRight,
  ArrowRightFromLine,
  ArrowLeftFromLine,
  ArrowLeftRight,
  CircleOff,
  BadgeQuestionMark,
} from "lucide-react";

export function intersectionTypeIcon(intersectionType: HGIntersectionType) {
  const iconClass = "size-3";
  if (intersectionType == HGIntersectionType.Contained) {
    return <Dot className={iconClass} data-icon="inline-start" />;
  } else if (intersectionType == HGIntersectionType.Exact) {
    return null;
    // return <Minus className={iconClass} data-icon="inline-start" />;
  } else if (intersectionType == HGIntersectionType.PartLeft) {
    return (
      <ArrowLeft className={iconClass} data-icon="inline-start" />
    );
  } else if (intersectionType == HGIntersectionType.PartRight) {
    return (
      <ArrowRight className={iconClass} data-icon="inline-start" />
    );
  } else if (intersectionType == HGIntersectionType.Starts) {
    return (
      <ArrowRightFromLine
        className={iconClass}
        data-icon="inline-start"
      />
    );
  } else if (intersectionType == HGIntersectionType.Ends) {
    return (
      <ArrowLeftFromLine
        className={iconClass}
        data-icon="inline-start"
      />
    );
  } else if (intersectionType == HGIntersectionType.Transit) {
    return (
      <ArrowLeftRight
        className={iconClass}
        data-icon="inline-start"
      />
    );
  } else if (intersectionType == HGIntersectionType.None) {
    return (
      <CircleOff className={iconClass} data-icon="inline-start" />
    );
  } else {
    return (
      <BadgeQuestionMark
        className={iconClass}
        data-icon="inline-start"
      />
    );
  }
}
